import type { MenuItemType } from '@zoomit/web-kit';

export const getNestedIndicatorButtons = (item: MenuItemType) => {
  const buttons: MenuItemType['indicatorButton'][] = [];
  if (item.indicatorButton) {
    buttons.push(item.indicatorButton);
  }
  if (item.children) {
    item.children.forEach((child) => {
      buttons.push(...getNestedIndicatorButtons(child));
    });
  }
  return buttons;
};
